import ApplicationService from "@mirage/services/ApplicationService";
import { useState, useEffect } from "react";

export const useAuthStatus = () => {
    const appService = new ApplicationService();
    const user = appService.getLoggedInUser();
    const userId = user?.id;
    const [loggedIn, setLoggedIn] = useState(false);
    const [checkingStatus, setCheckingStatus] = useState(true);
    useEffect(() => {
        appService.checkAuth().then((isOk) => {
            //Check server response and local storage information (from which atom state is written), that if makes sure that UI is compatible with actual status
            if (!isOk || !userId) {
                appService.logout();
            }
            setLoggedIn(isOk);
            setCheckingStatus(false);
        });
    }, [userId]);

    return { loggedIn, checkingStatus };
};
